/**
 *
 * Ad (JS)
 *
 * @author Takuto Yanagida @ Space-Time Inc.
 * @version 2020-03-30
 *
 */


(function () {
	const as = document.querySelectorAll('.ad-column .widget_media_image a');
	for (let i = 0; i < as.length; i += 1) {
		const a = as[i];
		a.addEventListener('click', (e) => {
			e.preventDefault();
			const href = a.href;
			if (typeof gtag !== 'undefined') gtag('event', 'click', { 'event_category': 'ad', 'event_label': href });
			setTimeout(() => { openWithNewTab(href); }, 200 );
		});
	}

	function openWithNewTab(href) {
		const a = document.createElement('a');
		a.setAttribute('target', '_blank');
		a.setAttribute('rel', 'noopener noreferrer');
		a.setAttribute('href', href);
		document.body.appendChild(a).click();
		document.body.removeChild(a);
	}
})();
